<div
  *ngIf="errors.length > 0"
  #summaryContainer
  class="error-summary"
  role="alert"
  tabindex="-1"
>
  <p class="error-summary-title">{{ titleKey | translate }}</p>
  <ul class="error-summary-list">
    <li *ngFor="let error of errors">
      <button
        type="button"
        class="error-summary-link"
        (click)="focusField(error.controlId)"
      >
        {{ error.messageKey | translate }}
      </button>
    </li>
  </ul>
</div>
